
import {
    IColumn
} from '@fluentui/react';
import { RootState } from 'app/store';
import { EControlType } from 'components/ControlWrapper';
import { IGridItem } from 'components/controls/CustomDetailList/IGridItem';
import { onRenderColumnFAM } from 'components/controls/Grid';
import {
    bcbs_config_section as IXrmTypes_bcbs_config_section
} from 'model/CRM';
import {
    IBenefit as FAM_IBenefit,
    IGroupConfigurationData as FAM_IGroupConfigurationData,
    INonStandard as FAM_INonStandard
} from 'model/FlexibleAttributeModel';
import { useMemo } from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { nonStandardPredicate } from "../../global/Application";


interface IProps extends TComponentConnectedProps {
    groupConfiguration?: FAM_IGroupConfigurationData;
    benefit?: FAM_IBenefit;
    section?: IXrmTypes_bcbs_config_section;
    disabled?: boolean;
    nonStandards?: FAM_INonStandard[];
    variant?: 'importer' | 'default'
}

type TNonStandardGridItem = IGridItem<FAM_INonStandard>;

const NonStandardNonGridView = (props: IProps) => {
    const config = props.state.data.config;

    const categoryGroupConfiguration = props.state?.data?.config?.cache?.map_bcbs_config_category_named['Group Configuration'];

    const columns = useMemo(() => {
        const columns: IColumn[] = [];

        columns.push({
            key: 'nonStandardName',
            name: 'Name',
            fieldName: 'name',
            isResizable: true,
            minWidth: 140,
            data: { bcbs_viewsortorder: 0 }
        });

        const predicate = nonStandardPredicate({ section: props.section, benefit: props.benefit, groupConfiguration: props.groupConfiguration })

        config?.attributes?.forEach(eachAttribute => {

            if (!eachAttribute.bcbs_nonstandard)
                return;

            const isOk = predicate(eachAttribute);

            if (!isOk)
                return;

            const eachAttributeMaster = props.state.data.config.cache.map_bcbs_config_masterattribute[eachAttribute._bcbs_config_masterattributeid_value!];

            const column: IColumn = {
                key: eachAttribute.bcbs_config_attributeid!,
                name: eachAttribute.bcbs_name!,
                minWidth: eachAttribute.bcbs_viewcolumnwidth ?? (eachAttribute?.bcbs_name?.length ?? 10) * 8,
                fieldName: eachAttribute.bcbs_config_attributeid,
                data: eachAttribute,
                onRender: onRenderColumnFAM(eachAttributeMaster.bcbs_attributetypecode as EControlType),
                isResizable: true
            };

            columns.push(column);
        });

        return columns.sort((a1, a2) => a1.data.bcbs_viewsortorder! - a2.data.bcbs_viewsortorder!);;

    }, []);

    const items = useMemo(() => {
            const items: TNonStandardGridItem[] = [];
            let target: FAM_INonStandard[] = [];

            if (props.groupConfiguration)
                target = props.groupConfiguration.nonStandards;

            if (props.benefit)
                target = props.benefit.nonStandards;

            // externally supplied non standards?
            if (props.nonStandards)
                target = props.nonStandards

            target.forEach((eNonStandard, index) => {

                // skip deactivated records/only show deactivated records if permitted at group config properties level (xnor)
                if (eNonStandard.deactivated !== props.state.data.json.showInActives?.value)
                    return;

                // skip non-standards that are not for my section
                if (props.section)
                    if (eNonStandard.sectionRef?.id !== props.section.bcbs_config_sectionid)
                        return;
                const item: TNonStandardGridItem = {
                    key: eNonStandard.id,
                    name: eNonStandard.name,
                    _index: index,
                    data: eNonStandard
                };

                eNonStandard.fields.forEach(eaField => {
                    const fieldName = eaField.configRef.id;
                    // lets always get the first one
                    // verified with William there will never be a Tier/PCP/Specialist mode for these.
                    const field = eaField.values[0];
                    item[fieldName] = field.value;
                });

                items.push(item);
            });

            return items;
        },
        [
            props.groupConfiguration?.nonStandards,
            props.benefit?.nonStandards,
            props.nonStandards,
            props.state?.data?.json?.showInActives?.value
        ]
    );

    const onRenderNotGrid = () => {
        return (
            <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                <tbody>
                    {items.map(item => (
                        <tr key={item.key} style={{ verticalAlign: 'top', borderTop: '2px solid #666' }}>
                            <td style={{ fontWeight: 'bold', padding: '8px 16px 8px 0', whiteSpace: 'nowrap', width: '1%' }}>
                                {item.name}
                            </td>
                            <td style={{ padding: '8px 0' }}>
                                <table style={{ borderCollapse: 'collapse' }}>
                                    <tbody>
                                        {item.data?.fields?.map(f => {
                                            const val = f.values
                                                .filter((v, i) => {
                                                    // Filter out empty/null values, but keep at least one if all are empty
                                                    if (i === 0) return true; // Always keep first
                                                    //@ts-ignore - v.value can be various types
                                                    const hasValue = v.value?.value || v.value?.name;
                                                    return hasValue; // Keep if has actual value
                                                })
                                                .map((v, i) => {
                                                    if (v.value?.type === 'bool')
                                                        return <span key={i}>{v.value.value ? 'Yes' : 'No'}</span>;
                                                    //@ts-ignore
                                                    return <span key={i}>{v.value?.value ?? v.value?.name ?? 'No Value for Field'}</span>;
                                                });
                                            return (
                                                <tr key={f.configRef?.id}>
                                                    <td style={{ fontWeight: 'bold', padding: '1px 12px 1px 0', whiteSpace: 'nowrap', width: '1%' }}>{f.name}</td>
                                                    <td style={{ padding: '1px 0' }}>{val}</td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    }

    const onRenderComponent = () => {

        return <div>


                {onRenderNotGrid()}

        </div>
    }


    return onRenderComponent();
}

function mapStateToProps(state: RootState) { return { state } }
const connector = connect(mapStateToProps);
type TComponentConnectedProps = ConnectedProps<typeof connector>;
export default connector(NonStandardNonGridView);
